import o from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import * as t from "react-dom";
var r = o({}, t), e = r.version;
r.render;
r.unmountComponentAtNode;
var m;
try {
  var a = Number((e || "").split(".")[0]);
  a >= 18 && (m = r.createRoot);
} catch {
}
//# sourceMappingURL=render.mjs.map
